// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__8s7qt","select":"Header_select__3V_Lt","clinic":"Header_clinic__3F1Kj"};